module.exports = "<div #widgetContainer></div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/components/resource/resource.component.html
// module id = ../../../../../src/app/modules/core/components/resource/resource.component.html
// module chunks = main